import { useNavigate } from 'react-router';

/**
 * 208 (#308, research.md R2): the ONE place admin decides where "back" goes — real history first,
 * a documented per-page fallback second. Ported directly from the app's own proven `PageHeader.tsx`
 * logic (`window.history.length > 1 ? window.history.back() : route(fallback)`), `navigate(-1)`
 * standing in for `window.history.back()`.
 *
 * Used by BOTH `PageHeader`'s own back control (when a `fallback` prop is given) AND, for form
 * pages, a footer Cancel button — one call per page, the SAME returned function passed to both
 * render sites, so there is exactly one decision of where "leave this page" goes per page, never
 * two independently-resolved ones (FR-004).
 */
export function useBackNavigation(fallback: string): () => void {
  const navigate = useNavigate();
  return () => {
    if (window.history.length > 1) navigate(-1);
    else navigate(fallback);
  };
}
